import axios from 'axios';
import { faAdd, faArrowDown, faTasks } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataTableDynamic from '../../../../component/Table/DataTableDynamic';

const Employee = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_EMPLOYEE = "/api/hrppsu/employee/employee";

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_EMPLOYEE}`,).then((data) => {
            setData(data);
        });
    }, []);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleAssign = (rowData) => {
        navigate(`/activity-hrppsu/employee/detail/${rowData.id.value}#personal`);
    };

    const actions = [{
        child: <button className='text-white text-xs rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 mx-1'>
            Action <FontAwesomeIcon icon={faArrowDown} color="white" />
        </button>,
        callback: (rowData) => handleAssign(rowData)
    }];

    return (
        <div>
            <div className='flex items-center justify-between px-5'>
                <h1>Data Pegawai</h1>
                <a href='/activity/new-employee' className='text-white text-xs rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 mx-1'>
                    Baru <FontAwesomeIcon icon={faAdd} color="white" />
                </a>
            </div>


            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTableDynamic
                    data={data}
                    elementClass="p-1"
                    columns={columns}
                    moduleActions={[]}
                    enableCustom={false}
                    actions={actions} />
            )}
        </div>
    )
}

export default Employee;
